export default __webpack_public_path__ + "static/idea-8d36763635bf27a94d4ecbd3e495e2d1.png";